import styled from 'react-emotion'
import { mobile, tablet, customDevice } from '../../../../../utils/mixins'
import {
  Typo54PumpkinOrangeBN9I,
  Typo16WhiteNBI,
  Typo24WhiteTwoBNB
} from '../../../../../themes/Fonts/Nort'

export const StatItemContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  padding-bottom: 2.0625em;
  ${mobile} {
    font-size: 14px;
    padding-bottom: 2.9em;
  }

  @media (-webkit-video-playable-inline) {
    video {
      display: initial;
    }
  }
`

export const StatsThumbnailVideo = styled('video')`
  width: 6.25em !important;
  height: 6.25em !important;
  object-fit: contain;
  ${mobile} {
    margin-right: 20px;
    width: 80px;
    height: 80px;
  }
`

export const StatDescriptionContainer = styled('div')`
  margin-left: 1.25em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${'' /* width: 10.5em; */} ${mobile} {
    justify-content: center;
    align-items: center;
    ${'' /* width: 13.6em; */} margin-left: 0;
  }
`
export const StatCount = styled(Typo54PumpkinOrangeBN9I)`
  line-height: normal;
  letter-spacing: normal;
  ${mobile} {
    font-size: 36px;
  }
  ${tablet} {
    font-size: 36px;
  }
`
export const StatDescription = styled(Typo16WhiteNBI)``
export const StatsDescriptionHeading = styled(Typo24WhiteTwoBNB)`
  line-height: normal;
  letter-spacing: 0.5px;
  ${tablet} {
    font-size: 20px;
  }
  ${customDevice(1024, 1100)} {
    font-size: 20px;
  }
`

export const StatsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 10px;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/StatsSection/StatItem/styledComponents.js